import { catchError } from "@/shared/utils/catchError";
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Быстрая проверка авторизации
      staleTime: 30 * 1000, // 30 секунд для обычных запросов
      gcTime: 5 * 60 * 1000, // 5 минут кэш

      // Отключаем автоматические refetch
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,

      // Отключаем автоматические повторы для простоты
      retry: false,
    },
    mutations: {
      // Отключаем автоматические повторы мутаций
      retry: false,

      // Простая обработка ошибок мутаций
      onError: (error: Error) => {
        console.error("Mutation error:", error);
        catchError(error, "Mutation");
      },
    },
  },
});

// Константы для query keys (для типизации и переиспользования)
export const queryKeys = {
  // Авторизация
  auth: {
    all: ["auth"] as const,
    me: () => [...queryKeys.auth.all, "me"] as const,
  },

  // Приложения/игры
  apps: {
    all: ["apps"] as const,
    lists: () => [...queryKeys.apps.all, "list"] as const,
    list: (filters?: Record<string, unknown>) =>
      [...queryKeys.apps.lists(), filters] as const,
    details: () => [...queryKeys.apps.all, "detail"] as const,
    detail: (id: string | number) => [...queryKeys.apps.details(), id] as const,
    bySlug: (slug: string) => [...queryKeys.apps.all, "slug", slug] as const,
  },
} as const;

// Утилиты для инвалидации кэша
export const invalidateQueries = {
  auth: () => queryClient.invalidateQueries({ queryKey: queryKeys.auth.all }),
  apps: () => queryClient.invalidateQueries({ queryKey: queryKeys.apps.all }),
  allData: () => queryClient.invalidateQueries(),
} as const;

// Утилиты для prefetch
export const prefetchQueries = {
  userProfile: async () => {
    await queryClient.prefetchQuery({
      queryKey: queryKeys.auth.me(),
      staleTime: 30 * 1000, // 30 секунд для быстрой проверки авторизации
    });
  },

  gamesList: async () => {
    await queryClient.prefetchQuery({
      queryKey: queryKeys.apps.lists(),
      staleTime: 5 * 60 * 1000, // Игры кэшируем дольше
    });
  },
} as const;
